module.exports = __webpack_public_path__ + "img/members.2348c08c.gif";